import { render, staticRenderFns } from "./PolicyDialog.vue?vue&type=template&id=77ae75a6&"
import script from "./PolicyDialog.vue?vue&type=script&lang=js&"
export * from "./PolicyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports